import f from "../../bundled_deps/.pnpm/camelcase@8.0.0/bundled_deps/camelcase/index.js";
const d = "embercom-prosemirror-retry-upload", l = "file-guid";
function m(t) {
  t.attrs = Object.assign({}, t.attrs, {
    fileGUID: { default: "" },
    uploadFailed: { default: !1 },
    failureReason: { default: "" },
    retryable: { default: !0 }
  });
  let r = t.toDOM;
  return t.toDOM = (e) => {
    var i, s, u;
    let a = r(e);
    if (a[1][l] = (i = e.attrs) == null ? void 0 : i.fileGUID, ((s = e.attrs) == null ? void 0 : s.uploadFailed) === !0) {
      let o = [];
      if (e.attrs.retryable) {
        let n = { class: d };
        n[`data-${l}`] = (u = e.attrs) == null ? void 0 : u.fileGUID, o = ["a", n, "try again"];
      }
      return [
        "div",
        { class: "embercom-prosemirror-upload-failed" },
        [
          "div",
          { class: "embercom-prosemirror-upload-failed-inner" },
          [
            "div",
            { class: "embercom-prosemirror-upload-info" },
            c(),
            e.attrs.failureReason
          ],
          o
        ],
        a
      ];
    }
    return a;
  }, t;
}
function b(t, r) {
  var e, a;
  (e = r.target) != null && e.classList.contains(d) && (t == null || t.commands.retryUpload(
    (a = r.target) == null ? void 0 : a.dataset[f(l)]
  ));
}
function A(t) {
  return t.type === "success" ? { fileGUID: "", uploadFailed: !1, failureReason: "" } : {
    uploadFailed: !0,
    failureReason: t.reason,
    retryable: t.retryable
  };
}
function c() {
  let t = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  t.setAttributeNS(null, "fill", "red"), t.setAttribute("class", "interface-icon o__standard o__by-text"), t.setAttributeNS(null, "viewBox", "0 0 16 16");
  let r = document.createElementNS("http://www.w3.org/2000/svg", "path");
  return r.setAttributeNS(null, "fill-rule", "oddeven"), r.setAttributeNS(
    null,
    "d",
    "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0-6.083a.701.701 0 0 1-.697-.621L6.88 4.615A1 1 0 0 1 7.872 3.5h.256a1 1 0 0 1 .993 1.115l-.424 3.68A.701.701 0 0 1 8 8.918zM8 12.5c-.714 0-1.25-.536-1.25-1.25S7.286 10 8 10s1.25.536 1.25 1.25S8.714 12.5 8 12.5z"
  ), t.appendChild(r), t;
}
export {
  l as UPLOAD_FILE_GUID,
  d as UPLOAD_RETRY_CLASS,
  b as handleUploadRetry,
  A as uploadResultToNodeAttrs,
  m as uploadable
};
